import { TemplateRef } from "@angular/core";

export class CustomDataTemplateRef {
    RefName: String;
    TemplateRef: TemplateRef<any>;
    DesignPageIndex: number;
}